import get from 'lodash/get';
import isEmpty from "lodash/isEmpty";
import { format } from "date-fns";
import arabicStrings from "react-timeago/lib/language-strings/ar";
import buildFormatter from "react-timeago/lib/formatters/buildFormatter";
import canUseDom from '../utils/can-use-dom';

export function storyColor(config = {}, story = {}) {
  const sectionId = get(story, ["sections", 0, "id"]);
  const menu = get(config, ['layout', 'menu'], []);
  const menuItem = menu.find(menuItem => menuItem.type === 'section' && menuItem['item-id'] === sectionId);
  return get(menuItem, ["data", "color"], '#000000');
}

export function sectionPath(config, section) {
  const sectionPathOnId = id  => {
    const section = get(config, ['sections'], []).find(section => section.id === id);
    if(!section) return "";
    return section["parent-id"] ? `${sectionPathOnId(section["parent-id"])}/${section.slug}` : section.slug;
  };

  if(!section) return "";
  return sectionPathOnId(section.id);
}


export function getNumberOfStoriesToShow(numberOfStoriesToShow) {
  return numberOfStoriesToShow ? parseInt(numberOfStoriesToShow) : 6;
}

export function getNumberOfCollectionToShow(numberOfColletionsToShow) {
  return numberOfColletionsToShow ? parseInt(numberOfColletionsToShow) : 6;
}

export function altTagOfHeroImages(story = {}){
  return story["hero-image-caption"] || story["headline"]
}


export function isExternalStory(story = {}) {
  switch(story['story-template']) {
    case 'news-elsewhere' : return get(story, ['metadata', 'reference-url'], '');
    case 'visual-story' : return `/${get(story, ['slug'], '')}`;
    default : return false;
  }
}


export function overrideLayouts(config, collection) {
  const layouts = get(config, ['theme-attributes', 'override_layouts']);

  if(!layouts) {
    return collection;
  }

  return Object.assign({}, collection, {
    items: collection.items.map((item, index) => Object.assign({}, item, {
      'associated-metadata': Object.assign({}, item['associated-metadata'], layouts[index])
    }))
  })
}

export function formatter(value, unit, suffix, date, config = {}) {
  const showDateForUnits = ['day', 'week', 'month', 'year'];

  if(get(config, ['theme-attributes', 'lang']) === 'ar') {
    const _formatter =  buildFormatter(arabicStrings);
    return _formatter.apply(this, [value, unit, suffix, date]);
  }
  if(unit === 'hour' && value > 23 || showDateForUnits.indexOf(unit) !== -1) {
    return format(new Date(date), 'DD MMM, YYYY');
  }
  return `${value} ${unit} ${suffix}`;
}

export function getCarousel(Slider = null, Slide = null) {
  return canUseDom ? Slider : Slide;
}

export function getInfiniteScrollApi(infiniteScrollType, params) {
  const FIELDS = "id,headline,metadata,slug,url,hero-image-s3-key,hero-image-metadata,first-published-at,last-published-at,alternative,published-at,author-name,author-id,sections,story-template,cards,tags,authors";
  switch(infiniteScrollType) {
    case 'section-based':
      return `/api/v1/stories?section-id=${params.sectionId}&fields=${FIELDS}&limit=5&offset=${5 * params.pageNumber}`;
    default:
      return `/api/v1/collections/curated-story-list?item-type=story&item-fields=${FIELDS}&limit=5&offset=${5 * params.pageNumber}`;
  }
}

export function getPrimaryColor(config = {}) {
  return get(config, ['theme-attributes', 'primary_color'], '');
}

export function getSocialShareStyle(config = {}) {
  return get(config, ['theme-attributes', 'social-share-style'], '');
}

export function getHorizontalSocialShare(config = {}) {
  const socialShareStyle = getSocialShareStyle(config);

  return socialShareStyle.includes('vertical') ? '' : socialShareStyle;
}

export function getStoryTags(story = {}) {
  return story.tags.reduce((acc, item) => {
    acc.push(item.name)
    return acc;
  }, []).toString();
}

export function getSocialShareProps(config = {}, story = {}) {
  return {
    url: story.slug,
    title: !isEmpty(story.summary) ? story.summary : story.headline,
    primaryColor: getPrimaryColor(config),
    hashtags: getStoryTags(story)
  }
}

export function updateBodyScroll(removeScroll = false) {
  if(canUseDom) {
    const element = document.getElementsByTagName('body')[0];
    return removeScroll ? element.classList.add('remove-body-scroll') : element.classList.remove('remove-body-scroll');
  }
}
